import React, { memo } from "react";
import uniqid from "uniqid";
import { useAppDispatch, useAppSelector } from "../../../Store";
import {
  allMessagesStore,
  setAllMessages,
} from "../../../Store/Slices/socket/AllMessagesSlice";
// import { socketStatusStore } from "../../../Store/Slices/socket/SocketSlice";
// import { SOCKET_CONNECTION_TYPES } from "../../utils/Enum";
import AppMessageBoxWrapper from "../UtilsComponents/AppMessageBoxWrapper";
import AppSmallButton from "../UtilsComponents/AppSmallButton";
import useMessagesData from "../../hooks/useMessagesData";

interface Props {
  userMessage: boolean;
  item: any;
  rowWrapperStyle?: React.CSSProperties | undefined;
  containerStyle?: React.CSSProperties | undefined;
  time: string;
  readStatus?: "sent" | "delivered" | "seen";
  [otherProps: string]: any;
}

const AppRenderFlowButtons: React.FC<Props> = ({
  userMessage,
  item,
  rowWrapperStyle,
  containerStyle,
  time,
  readStatus = "delivered",
  otherProps,
}) => {
  const dispatch = useAppDispatch();
  const { typingStatus, sessionId, liveChatConnected } = useAppSelector(allMessagesStore);
  // const { socket } = useAppSelector(socketStatusStore);
  const { postBotUserQuery } = useMessagesData();

  const handleOptionBtnClick = async (item: any) => {
    if (!item?.value?.nodeId) {
      console.warn("nodeId is empty wrong button format recieved", item);
      return;
    }

    if (!item?.value?.qid) {
      console.warn("qid is empty wrong button format recieved", item);
      return;
    }

    if (!item?.value?.stage) {
      console.warn("stage is empty wrong button format recieved", item);
      return;
    }

    let data = {
      type: "text",
      value: item?.value?.text,
      journey: {
        nodeId: item?.value?.nodeId,
        qid: item?.value?.qid,
        stage: item?.value?.stage,
      },
      session_id: sessionId,
      isUser: true,
    };

    dispatch(setAllMessages([data]));
    // if (socket?.connected) {
    //   socket?.emit(SOCKET_CONNECTION_TYPES.BOT_CONVERSATION, data);
    // }
    postBotUserQuery(data);
  };

  return (
    <AppMessageBoxWrapper
      key={uniqid()}
      userMessage={userMessage}
      time={time}
      isMedia={true}
      isButton={true}
      divStyle={containerStyle}
      rowStyle={rowWrapperStyle}
    >
      <AppSmallButton
        variant="outline"
        onClick={() => handleOptionBtnClick(item)}
        disabled={liveChatConnected ? true : false}
        style={{ pointerEvents: typingStatus ? "none" : "auto" }}
      >
        {item?.value?.text}
      </AppSmallButton>
    </AppMessageBoxWrapper>
  );
};

export default memo(AppRenderFlowButtons);
